<div class="w-full h-full bg-[#fcfcfd] z-[999999999999] flex justify-center items-center">
  <app-lottie-loader [size]="256"></app-lottie-loader>  
</div>